/**
 * Admin 403 - Unauthorized Access Component
 * Displays when token is missing, invalid, or expired
 */

import { useNavigate } from 'react-router-dom';

export const Admin403 = () => {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate('/x9s4k-portal-72/admin/login');
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px',
      position: 'relative'
    }}>
      {/* Debug indicator - "Hello" in the center background */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: '4rem',
        fontWeight: 800,
        color: 'rgba(255, 255, 255, 0.2)',
        pointerEvents: 'none',
        zIndex: 0,
        userSelect: 'none'
      }}>
        Hello
      </div>
      
      <div style={{
        background: '#ffffff',
        padding: '60px 40px',
        borderRadius: '20px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{
          fontSize: '4rem',
          marginBottom: '20px'
        }}>
          🔒
        </div>
        <h1 style={{
          fontSize: '2rem',
          fontWeight: 800,
          marginBottom: '16px',
          color: '#1a1a1a'
        }}>
          403 - Not Authorized
        </h1>
        <p style={{
          fontSize: '1.125rem',
          color: '#495057',
          lineHeight: 1.7,
          marginBottom: '30px'
        }}>
          You do not have permission to access this admin panel.
          <br />
          A valid token is required.
        </p>
        <button
          onClick={handleGoToLogin}
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: '#ffffff',
            border: 'none',
            padding: '15px 40px',
            borderRadius: '50px',
            fontSize: '1.125rem',
            fontWeight: 700,
            cursor: 'pointer',
            transition: 'transform 0.3s'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          Go to Login
        </button>
      </div>
    </div>
  );
};

